<template>
    <div class="page" v-if="isDataLoaded">

        <div class="item" v-if="!isEmpty(list)">
            <div class="bd1" v-for="(item, index) in list" :key="index" @click="toUrl('/article/detail?id=' + item.id)">
                <div class="sc-item" data-flex="cross:center">
                    <div data-flex-box="1">{{ item.title }}</div>
                    <img src="../../assets/images/left.png" alt="">
                </div>
            </div>
        </div>
        <div v-else>
            <van-empty description="暂无" />
        </div>
    </div>
</template>

<script>
import mix1 from '@/mixins/page'
import { uiShowLoading, uiHideLoading, uiAlert, uiConfirm } from '@/utils/ui'
import { delayAsync } from '@/utils/common'
import { Button, Tab, Tabs, Progress, Empty } from 'vant'
import MgPopup from '@/components/common/mg-popup'

export default {
    mixins: [mix1],
    components: {
        MgPopup,
        [Button.name]: Button,
        [Tab.name]: Tab,
        [Tabs.name]: Tabs,
        [Progress.name]: Progress,
        [Empty.name]: Empty,

    },
    data() {
        return {
            showPivot: false,
            searchForm: {
                categoryId: 0,
            },
            list: []
        }
    },
    methods: {

        toUrl(url) {
            this.$router.push(url)
        },
        async getList() {

            uiShowLoading()
            await delayAsync(500)

            const promise = this.apiGet('category.list', this.searchForm)

            let apiResult = null

            try {
                apiResult = await promise
            } catch (ex) {
                apiResult = null
            }

            uiHideLoading()

            if (this.hasException(apiResult)) {
                return
            }
            this.isDataLoaded = true
            this.list = apiResult.list
        },
    },
    mounted() {

    },
    created() {
        let query = this.$route.query
        this.searchForm.categoryId = query.id

        this.asyncTile(query.name)
        this.getList()
    }
}
</script>

<style lang="less">
.rd {
    .van-progress {
        width: 200px;
    }
}

.van-empty__image {
    width: 500px;
    height: 500px;
}
</style>
<style lang="less" scoped>
.page {

    .item {
        width: 100%;

        .bd1 {
            background: #fff;
            width: 100%;
            margin: 0 auto;
            border-radius: 12px;
        }
    }

    .sc-item {
        padding: 30px;
        box-sizing: border-box;
        border-bottom: 1px solid #f8f8f8;

        div {
            font-size: 15px;
            font-weight: bold;
        }

        img {
            width: 15px;
            height: 24px;
        }
    }

    .row1 {
        //   border-bottom: 1px solid #f8f8f8;
        font-size: 15px;
        color: #333;
        padding: 20px 8px;

        >span:nth-child(1) {
            width: 80px;
            color: #333;
            text-align: right;
        }

        >span:nth-child(2),
        >div:nth-child(2) {
            >span {
                font-size: 13px;
                color: #999;
                padding-right: 10px;
            }

            font-size: 13px;
            color: #333;
            text-align: right;
        }
    }
}
</style>